import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setSelectedInstance } from './../../../../../actions/closeLoop/apmDashboard/instancesActions';
import PropTypes from "prop-types";


const amazonEC2 = require('./../../../../../images/apmDashboard/amazon-ec2.png');


function InstanceInfo(props) {

    const handleNavigate = (e) => {
        e.preventDefault();
        const instanceId = e.target.value;
        props.markSelectedInstance(instanceId);
        props.history.push(`/close_loop/running/bench-instances/health/${props.region}/${instanceId}`);
    }

    return (
        <Card >
            <Card.Img variant="top" src={amazonEC2} />
            <Card.Body>
                <Card.Title>Instance</Card.Title>
                <h5 style={{ textTransform: "lowercase" }}>{ props.instance }</h5>
                <Button variant="primary" onClick={handleNavigate} value={props.instance}>Health Check</Button>
            </Card.Body>
        </Card>
    )
}

const mapDispatchToProps = (dispatch) => ({
    markSelectedInstance: (payload) => dispatch(setSelectedInstance(payload)),
});

InstanceInfo.propTypes = {
    markSelectedInstance: PropTypes.func,
    history: PropTypes.string,
    region: PropTypes.string,
    instance: PropTypes.string,
};
InstanceInfo.defaultProps = {
    history: '',
    region: '',
    instance: '',
};

export default connect(undefined, mapDispatchToProps)(InstanceInfo);
